/**
 * Public-facing legal disclaimer. Retailer names/brands/locations shown on the
 * public site are demonstration placeholders and do not imply partnership or
 * participation until formal agreements are signed. Reused in the site footer,
 * under the grocer directory grid, and on the press/newsroom page.
 */
export default function SiteDisclaimer({ className = '' }) {
  return (
    <p
      className={`text-xs italic text-gray-500 leading-relaxed ${className}`}
      data-testid="site-disclaimer"
    >
      <span className="font-semibold not-italic text-gray-600">Disclaimer:</span> Retailer names,
      brands, and locations displayed on this site are for demonstration purposes only and do not
      imply partnership, endorsement, or participation in the DealShaq platform. Actual participating
      grocers and charities are confirmed through formal agreements and may differ from those shown.
      All discounts and savings are illustrative and subject to availability.
    </p>
  );
}
